import { NgModule } from "@angular/core";
import { ChipsInputFormComponent } from './chips-input-form/chips-input-form.component';
import { DynamicChipsInputComponent } from './dynamic-chips-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ChipsInputDesignComponent } from './chips-input-design/chips-input-design.component';
import { MaterialModule } from '../../material.module';

@NgModule({
    declarations: [
        ChipsInputDesignComponent,
        ChipsInputFormComponent, DynamicChipsInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule
    ],
    exports: [
        ChipsInputFormComponent,
    ],
    entryComponents: [
        DynamicChipsInputComponent
    ]
})
export class ChipsInputModule {}